<template>
  <v-form ref="offerPageEditForm" v-model="valid" class="offer-page-page">
    <v-row>
      <div class="back-btn" @click="$router.push({name: 'offer-page-index'})">
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
        </svg>
      </div>
      <v-col cols="12">
        <h1>Договор оферты</h1>
      </v-col>
      <v-col cols="12" sm="10" md="10" xl="8">
        <v-text-field
            v-model="offerPage.name"
            label="Название"
            outlined
            required
            :rules="[rules.required]"
        ></v-text-field>
        <editor api-key="8z95zxrw4xtjnn7a2unyi14ym91kzk8j6549luv0ow3cmn2i" v-model="offerPage.data" :init="{}" :toolbar="toolbar" :plugins="plugins"/>
        <v-btn v-if="id" @click="update">Сохранить</v-btn>
        <v-btn v-else @click="create">Создать</v-btn>
      </v-col>
      <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          right
          top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
// @ is an alias to /src
import PageService from './../../api/PageService'
import Editor from '@tinymce/tinymce-vue'
import CategoryService from "@/api/CategoryService";

export default {
  name: 'OfferPageEdit',
  props: {
    id: [Number, String]
  },
  components: {Editor},
  data: () => ({
    plugins: 'advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount',
    toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | code ',
    snackbar: false,
    timeout: 2000,
    snackbarText: '',
    snackbarColor: '',
    rules: {
      required: value => !!value || 'Нужно заполнить',
      requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
    },
    valid: true,
    image: null,
    tab: '',
    tabLang: '',
    categories: [],
    offerPage: {
      name: "",
      data: ""
    },
    loading: true,
    loadingButton: false,
  }),
  mounted() {
    if (this.id) {
      PageService.getOfferPage(this.id)
          .then(response => {
            this.offerPage = response.data;
            this.loading = false
          });
    }

  },
  methods: {
    create() {

      this.loadingButton = true;
      let formData = this.getData();

      PageService.createOfferPage(formData).then(response => {
        this.snackbar = true;
        this.snackbarText = 'Страница успешно обновлена';
        this.snackbarColor = 'success';
        this.$router.push({name: 'offer-page-edit', params: {id: response.data.id}})
      }).catch(error => {
        this.snackbar = true;
        this.snackbarText = 'Ошибка при обновлении страницы';
        this.snackbarColor = 'error';
      }).finally(() => {
        this.loadingButton = false
      })
    },
    update() {

      this.loadingButton = true;
      let formData = this.getData();
      let id = this.id

      PageService.updateOfferPage(id, {...formData, ...{_method: "patch"}}).then(response => {
        this.snackbar = true;
        this.snackbarText = 'Страница успешно обновлена';
        this.snackbarColor = 'success';
      }).catch(error => {
        this.snackbar = true;
        this.snackbarText = 'Ошибка при обновлении страницы';
        this.snackbarColor = 'error';
      }).finally(() => {
        this.loadingButton = false
      })
    },
    getData() {
      return {
        data: this.offerPage.data,
        name: this.offerPage.name,
      };
    }
  },
}
</script>


<style scoped lang="scss">

</style>
